import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var overlayStyle = createRuntimeFn({defaultClassName:'fx_c76f37be_19epc5k2',variantClassNames:{overlayTheme:{light:'fx_c76f37be_19epc5k3',dark:'fx_c76f37be_19epc5k4',transparent:'fx_c76f37be_19epc5k5'}},defaultVariants:{},compoundVariants:[]});

export { overlayStyle };
//# sourceMappingURL=overlay.vanilla.mjs.map
